import React, { useEffect, useRef } from "react";
import ReactTable from "react-table";

import { makeStyles } from "@material-ui/core/styles";
import Warning from "@material-ui/icons/Warning";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { bookingApi } from "functions/apis";
import { token } from "functions/Helper";

const styles = {
  cardIconTitle: { ...cardTitle, marginTop: "15px", marginBottom: "0px" }
};
const useStyles = makeStyles(styles);

// Matches Sindo.Booking.Enums.AgentQuotaMutationType
const MUTATION_TYPE = {
  0: "Generated",
  10: "Admin Add",
  20: "Admin Release",
  30: "Booking Deduct",
  40: "Booking Release",
  50: "Transfer Deduct",
  60: "Transfer Release"
};

// AgentQuotaMutationStatus.Error
const STATUS_ERROR = 20;

export default function QuotaErrorList() {
  const source = useRef(new AbortController());

  const canWrite =
    token["booking.agent_daily_quotas.write"] === "allowed" ||
    token.is_admin === "True";

  const [data, setData] = React.useState([]);
  const [pages, setPages] = React.useState(0);
  const [reload, setReload] = React.useState(0);
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    return () => source.current.abort();
  }, []);

  const retry = mutationID => {
    bookingApi
      .post("/AgentQuotaMutations/Retry/" + mutationID, null, {
        signal: source.current.signal
      })
      .then(() => setReload(r => r + 1))
      .catch(error => console.log(error));
  };

  useEffect(() => {
    setLoading(true);
    bookingApi
      .get("/AgentQuotaMutations", {
        signal: source.current.signal,
        params: {
          filter: { status: STATUS_ERROR, sort: 1 },
          pagination
        }
      })
      .then(data => {
        setData(
          data.records.map(record => ({
            ...record,
            agentCode: record.agent?.code,
            routeCode: record.route?.code,
            dateLabel: record.date?.substring(0, 10),
            typeLabel: MUTATION_TYPE[record.mutationType],
            createdAtLabel: record.createdAt
              ?.replace("T", " ")
              .substring(0, 19),
            actions: canWrite ? (
              <Button
                color="warning"
                size="sm"
                onClick={() => retry(record.id)}
              >
                Retry
              </Button>
            ) : null
          }))
        );
        setPages(Math.ceil(data.totalRecords / pagination.pageSize));
        setLoading(false);
      })
      .catch(error => console.log(error));
  }, [pagination, reload]);

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="warning" icon>
            <CardIcon color="warning">
              <Warning />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>QUOTA ERRORS</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              manual
              pages={pages}
              page={pagination.pageIndex - 1}
              pageSize={pagination.pageSize}
              onPageChange={page =>
                setPagination({ ...pagination, pageIndex: page + 1 })
              }
              onPageSizeChange={(pageSize, page) =>
                setPagination({ pageSize, pageIndex: page + 1 })
              }
              loading={loading}
              data={data}
              filterable={false}
              columns={[
                { Header: "When", accessor: "createdAtLabel" },
                { Header: "Agent", accessor: "agentCode" },
                { Header: "Route", accessor: "routeCode" },
                { Header: "Date", accessor: "dateLabel" },
                { Header: "Time", accessor: "time" },
                { Header: "Type", accessor: "typeLabel" },
                { Header: "Delta", accessor: "delta" },
                { Header: "Error", accessor: "error" },
                { Header: "By", accessor: "createdBy" },
                {
                  Header: "Actions",
                  accessor: "actions",
                  sortable: false,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              showPaginationTop
              showPaginationBottom={false}
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
